import Vue from "vue";
import VueWaypoint from "vue-waypoint";

Vue.use(VueWaypoint);
